//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  fetch() {
    return this.$axios.$get('/api/ab-tests/29').then(({ status, data }) => {
      if (status === 'success') this.test = data
    })
  },

  data() {
    return {
      test: {}
    }
  },

  computed: {
    hasTest() {
      return Boolean(this.test?.name)
    },

    isVariant() {
      return this.test?.name === 'ant-people'
    },

    variantName() {
      return this.isVariant ? 'people' : 'sand'
    }
  },

  watch: {
    test(testValue) {
      this.$bus.$emit('init-test', { client_test_29: testValue.name })
    }
  }
}
